import { Show } from "solid-js"
import "@/datox/v2/tokens.css"
import "@/datox/v2/sign-in.css"

// The Lesha Bank sign-in (the "New design" flag on; DEMO-SWEEP static §2): a light V2 card with the bank's logo, one
// Microsoft button and the Entra line. The flag-off app keeps Bobur's dark Datox page (datox/auth-ui.tsx).
export function LeshaSignIn(props: {
  logoAlt: string
  title: string
  subtitle: string
  button: string
  footer: string
  error?: string
  busy: boolean
  disabled: boolean
  onLogin: () => void
}) {
  return (
    <main class="dx-v2 dx-signin">
      <section class="dx-signin-card" aria-labelledby="dx-signin-title">
        <img class="dx-signin-logo" src="/lesha-bank-logo.png" alt={props.logoAlt} />
        <h1 id="dx-signin-title">{props.title}</h1>
        <p class="dx-signin-subtitle">{props.subtitle}</p>
        <Show when={props.error}>
          <p class="dx-signin-error" role="alert">{props.error}</p>
        </Show>
        <button type="button" class="dx-signin-button" disabled={props.disabled} aria-busy={props.busy} onClick={() => props.onLogin()}>
          <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          {props.button}
        </button>
        <p class="dx-signin-footer">{props.footer}</p>
      </section>
    </main>
  )
}
